import axios from "axios";
import configs from "../../configs/apiConfigs";

export const verifyApiKey = (apiKey: string, clinicId: string) => {
    return axios.get(configs.API_URL + 'utilities/' + apiKey + '/' + clinicId + '/', {
        headers: {
            'xprApp': 'front'
        }
    }).then(response => ({ response }), error => ({ error }));
}